/**
 * Tabs of the contract detail page (fiche 22803 / design `contrat.onglets`)
 * — page chrome, declared as config with stable values: `details`,
 * `assure`, `primes` (count), `garanties`, `sinistres` (count),
 * `documents`, `pieces` (count of pieces « EN ATTENTE », orange).
 */

import type { BadgeVariant } from '@components/base/display';

/** Stable tab values. */
export type ContractDetailTabKey =
  | 'details'
  | 'assure'
  | 'primes'
  | 'garanties'
  | 'sinistres'
  | 'documents'
  | 'pieces';

/** Which counter a tab shows next to its label. */
export type ContractDetailTabCount = 'premiums' | 'claims' | 'pendingPieces';

export interface ContractDetailTab {
  key: ContractDetailTabKey;
  label: string;
  /** Counter shown as a badge (only once loaded and > 0). */
  count?: ContractDetailTabCount;
  countVariant?: BadgeVariant;
}

/** Tabs in design order. */
export const CONTRACT_DETAIL_TABS: readonly ContractDetailTab[] = [
  { key: 'details', label: 'Détails' },
  { key: 'assure', label: 'Assuré' },
  { key: 'primes', label: 'Primes', count: 'premiums' },
  { key: 'garanties', label: 'Garanties' },
  { key: 'sinistres', label: 'Sinistres', count: 'claims' },
  { key: 'documents', label: 'Documents' },
  { key: 'pieces', label: 'Pièces', count: 'pendingPieces', countVariant: 'warning' },
];

/** Tab opened on arrival. */
export const CONTRACT_DETAIL_DEFAULT_TAB: ContractDetailTabKey = 'details';
